<template>
  <main class="main">
    <portal to="headerTitle">
      {{ $t('admin.pageSeasonCalendars.title') }}
    </portal>
    <card :title="$t('admin.pageSeasonCalendars.card.seasonCalendar')" cols="12">
      <hm-card-inner :full-size="true">
        <hm-card-inner-line :clickable="true" :title="$t('admin.pageSeasonCalendars.card.seasonCalendarRatePlan')" @click="routeToSeasonCalendar('DayRate')" />
        <hm-card-inner-line v-if="hasLicense('Packages')" :clickable="true" :title="$t('admin.pageSeasonCalendars.card.seasonCalendarPackage')" @click="routeToSeasonCalendar('Package')" />
      </hm-card-inner>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';

export default {
  name: 'PageSeasonCalendars',

  mixins: [HotelmeisterMixin],

  data() {
    return {
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    routeToSeasonCalendar(ratePlanType) {
      this.$router.push({
        name: 'seasonCalendar',
        params: {
          ratePlanType: ratePlanType,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageSeasonCalendars.vue